import { addModuleStyles } from '@glu/theming/glu-css-override';

const themeKey = 'legacyModal';

const defaultTheme = ({ legacy, palette }) => (legacy ? undefined : {
  backgroundColor: palette.background,
  infoColor: palette.info,
  errorColor: palette.error,
  closeIcon: 'x-circle',
  focusColor: palette.focus.normal,
  window: {
    border: 'none',
    borderLeftWidth: 4,
    borderRadius: 0
  },
  header: {
    backgroundColor: 'transparent',
    fontSize: 20,
    iconColor: palette.accent,
    iconSize: 48,
    iconSpacing: 16,
    textTransform: 'uppercase'
  },
  body: {
    fontSize: 16
  },
  icons: {
    info: 'info-circle',
    error: 'exclamation-triangle',
    warning: 'exclamation-circle',
    success: 'checkmark-circle'
  }
});

const styles = ({ legacyModal }) => {
  if (!legacyModal) {
    return {};
  }

  const {
    backgroundColor, infoColor, errorColor, header, body, window, focusColor
  } = legacyModal;

  return {
    root: {
      '&.glu-modal': {
        '& .modal-content': {
          backgroundColor,
          border: window.border,
          borderLeft: `${window.borderLeftWidth}px solid ${infoColor}`,
          borderRadius: window.borderRadius,
          textAlign: 'center'
        },
        '& .dialog-error .modal-content, &.glu-modal .dialog-warning .modal-content': {
          borderLeftColor: errorColor
        },
        '& .modal-header': {
          backgroundColor: header.backgroundColor,
          textTransform: header.textTransform
        },
        '& .modal-header .close': {
          opacity: 1,
          position: 'absolute',
          right: 20,

          '&:focus': {
            outlineColor: focusColor
          }
        },
        '& .modal-footer': {
          textAlign: 'center'
        },
        '& .modal-title': {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          fontSize: header.fontSize,
          fontWeight: 'normal'
        },
        '& .modal-header .modal-title > .icon-wrapper': {
          height: 'inherit',
          marginBottom: header.iconSpacing,
          width: 'inherit',

          '& svg': {
            fill: '#CCC',
            height: header.iconSize,
            width: header.iconSize
          }
        },
        '& .modal-body': {
          fontSize: body.fontSize
        }
      }
    }
  };
};

addModuleStyles(styles, themeKey, defaultTheme);
